import { render, staticRenderFns } from "./YizhiAdmin.vue?vue&type=template&id=475fe3bc&scoped=true&"
import script from "./YizhiAdmin.vue?vue&type=script&lang=js&"
export * from "./YizhiAdmin.vue?vue&type=script&lang=js&"
import style0 from "./YizhiAdmin.vue?vue&type=style&index=0&id=475fe3bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475fe3bc",
  null
  
)

export default component.exports